
export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-[#0A1A3F]">
      <div className="absolute inset-0">
        <div className="absolute inset-0 w-full h-full">
          <img
            src="https://public.readdy.ai/ai/img_res/7d6d04dec56b2e1fa6f41d831d308bb5.jpg"
            alt="AI Infrastructure for Global Capital"
            title="VAZ Global Capital AI infrastructure"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A1A3F]/70 via-[#0A1A3F]/50 to-[#0A1A3F]/80"></div>
      </div>

      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 text-center pt-32 pb-24">
        <p className="opacity-0 animate-fade-up text-xs font-sans font-semibold tracking-[0.3em] uppercase text-[#D4AF37] mb-8">
          VAZ Global Capital
        </p>

        <h1 className="opacity-0 animate-fade-up-delay-1 text-5xl md:text-7xl lg:text-[5.5rem] font-serif text-white leading-[1.05] mb-0">
          AI Infrastructure for
          <br />
          <span className="text-[#D4AF37]">Serious Operators.</span>
        </h1>

        <div className="opacity-0 animate-slide-right w-16 h-[1px] bg-[#D4AF37]/60 mx-auto my-10"></div>

        <p className="opacity-0 animate-fade-up-delay-2 text-lg md:text-xl font-sans font-light text-white/70 max-w-2xl mx-auto leading-relaxed mb-14">
          We design and deploy structured AI operating systems for Home Services, Professional Services, and Healthcare organizations seeking scalable, measurable growth.
        </p>

        <div className="opacity-0 animate-fade-up-delay-3 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#consultation"
            className="bg-[#D4AF37] text-[#0A1A3F] px-8 py-3.5 rounded-full text-sm font-semibold hover:bg-[#C19B2E] transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Book a Strategic Consultation
          </a>
          <a
            href="#framework"
            className="border border-white/30 text-white/90 px-8 py-3.5 rounded-full text-sm font-medium hover:border-[#D4AF37] hover:text-[#D4AF37] transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Explore Our Framework
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 opacity-0 animate-fade-in-delay">
        <div className="w-6 h-10 border border-white/30 rounded-full flex items-start justify-center p-1.5">
          <div className="w-1 h-2.5 bg-white/50 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}
